var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBarchart = function SvgBarchart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 261,
    height: 95,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B4B4B4",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 35.521h17.871v59.298H.5zM80.74 13.971h17.871v80.85H80.74zM27.377.822h17.871V94.82H27.377zM54.06 24.952h17.871v69.869H54.06zM107.42 28.364h17.871v66.458H107.42zM136.064 13.971h17.871V94.82h-17.871zM216.305 13.971h17.871v80.85h-17.871zM162.943.822h17.871V94.82h-17.871zM189.625 24.952h17.871v69.869h-17.871zM242.984 35.521h17.871v59.3h-17.871z"
  }))));
};
export { SvgBarchart as ReactComponent };
export default __webpack_public_path__ + "images/barchart.svg";